import * as React from "react";
import { cn } from "../lib/cn";

export interface StatCardProps {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
  trend?: { value: string; direction: "up" | "down" | "flat" };
  /** Tint the number itself — e.g. text-clinical-high for a count that needs attention. */
  valueClassName?: string;
  className?: string;
}

/** Bare big-number stat, per the imported design's Overview row — no card chrome. Several
 * metrics side by side read as one dashboard scoreboard, not a grid of separate boxes. */
export function StatCard({ label, value, icon, trend, valueClassName, className }: StatCardProps) {
  return (
    <div className={cn("min-w-0", className)}>
      <div className="flex items-center gap-2">
        {icon && <span className="text-primary-600">{icon}</span>}
        <p className={cn("text-[clamp(1.75rem,4vw,3rem)] font-semibold leading-[0.95]", valueClassName ?? "text-charcoal-900")}>
          {value}
        </p>
      </div>
      <p className="mt-2.5 text-[10.5px] font-semibold uppercase tracking-[0.08em] text-charcoal-500">{label}</p>
      {trend && (
        <p
          className={cn(
            "mt-1 text-xs font-medium",
            trend.direction === "up" && "text-clinical-success",
            trend.direction === "down" && "text-clinical-high",
            trend.direction === "flat" && "text-charcoal-500",
          )}
        >
          {trend.value}
        </p>
      )}
    </div>
  );
}
